import script from "./TeamMember.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMember.vue?vue&type=script&setup=true&lang=js"

import "./TeamMember.vue?vue&type=style&index=0&id=768308b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768308b6"]])

export default __exports__